import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { CustomDomainStatus } from "../components/shop/popups/CustomDomainPopups/customDomainEntry";

export type OwnershipVerification = {
  type: string;
  name: string;
  value: string;
};

export type CustomDomainData = {
  customDomainUrl: string | null;
  isActive: boolean;
  domainStatus: CustomDomainStatus;
  ownershipVerification: OwnershipVerification | null;
  canDeleteOwnership?: boolean;
};

export interface CustomDomainState {
  data: CustomDomainData | null;
}

const initialState: CustomDomainState = {
  data: null,
};

const customDomainSlice = createSlice({
  name: "customDomain",
  initialState,
  reducers: {
    setCustomDomainData(state, action: PayloadAction<CustomDomainData | null>) {
      state.data = action.payload;
    },
  },
});

export const { setCustomDomainData } = customDomainSlice.actions;

// Selectors
export const selectCustomDomainData = (state: {
  customDomain: CustomDomainState;
}) => state.customDomain?.data;

export default customDomainSlice.reducer;
